import { render, staticRenderFns } from "./CoinSelector.vue?vue&type=template&id=278d7ee2"
import script from "./CoinSelector.vue?vue&type=script&lang=js"
export * from "./CoinSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports